import { render, staticRenderFns } from "./UsuarioExternoView.vue?vue&type=template&id=0c954489"
import script from "./UsuarioExternoView.vue?vue&type=script&lang=js"
export * from "./UsuarioExternoView.vue?vue&type=script&lang=js"
import style0 from "./UsuarioExternoView.vue?vue&type=style&index=0&id=0c954489&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports